function capitalizeFirstLetter(str) { return str.charAt(0).toUpperCase() + str.slice(1) }
function enumToString(str) { return str ? str.split('_').map(e => capitalizeFirstLetter(e)).join(' ') : '' }

function titleCase(str) {
  if (!str) return '-'
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export default { capitalizeFirstLetter, enumToString, titleCase }
